function randomString(length, withNumeric=false) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    if (withNumeric) possible += "0123456789"

    for (var i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

const newID = (slug, hashLength=5, withNumeric=true) => {
    if (typeof slug == 'undefined' || slug == null) {
        slug = randomString(5, true)
    }
    return slug + '_' + Date.now() + randomString(hashLength, withNumeric)
}

export default newID